/**
 * Initializes all event listeners for the header UI components.
 */
export function init() {
    document.addEventListener('click', (e) => {

        // --- 1. Notification Toggle ---
        const notifTrigger = e.target.closest('.th-bp-header-notification-container .th-bp-notif-logo');
        if (notifTrigger) {
            e.preventDefault();
            e.stopPropagation();

            const container = notifTrigger.closest('.th-bp-header-notification-container');
            const dropdown = container.querySelector('ul'); // Helper check if exists

            // Toggle logic
            if (container) {
                // Close other dropdowns first
                document.querySelector('.th-bp-header-messenger-container ul.show_dd')?.classList.remove('show_dd');

                // Toggle current list
                const list = container.querySelector('ul');
                if (list) list.classList.toggle('show_dd');
            }
            return;
        }

        // --- 2. Notification Tabs (Read / Unread) ---
        // Fix: Target the specific wrapper the CSS expects (parent of the title bar)
        const notifTab = e.target.closest('.notification-title .tab-read, .notification-title .tab-unread');
        if (notifTab) {
            e.preventDefault();
            e.stopPropagation(); // Keep dropdown open

            // 1. Identify the Title Bar
            const titleBar = notifTab.closest('.notification-title');

            // 2. Identify the Wrapper (The element that needs 'data-tab')
            // Original code used: e.target.parentElement.parentElement
            const wrapper = titleBar ? titleBar.parentElement : null;

            if (wrapper) {
                // 3. Set Mode
                const mode = notifTab.classList.contains('tab-unread') ? 'unread' : 'read';
                wrapper.setAttribute('data-tab', mode);

                // 4. Update Visual Active State (Optional but recommended)
                titleBar.querySelectorAll('span').forEach(el => el.classList.remove('active'));
                notifTab.classList.add('active');
            }
            return;
        }

        // --- 3. Messenger Toggle ---
        const messengerTrigger = e.target.closest('.th-bp-header-messenger-container .th-bp-inbox-logo');
        if (messengerTrigger) {
            e.preventDefault();
            e.stopPropagation();

            const container = messengerTrigger.closest('.th-bp-header-messenger-container');

            if (container) {
                // Close notifications if open
                document.querySelector('.th-bp-header-notification-container ul.show_dd')?.classList.remove('show_dd');

                const list = container.querySelector('ul');
                if (list) list.classList.toggle('show_dd');
            }
            return;
        }

        // --- 4. Login Modal ---
        const loginToggle = e.target.closest('.th-bp-logged-out a');
        if (loginToggle) {
            e.preventDefault();
            const modal = document.getElementById('tophive-signin-signup');
            if (modal) modal.classList.add('open');
        }

        // --- 5. Vertical Nav ---
        const vNavToggle = e.target.closest('.v-nav-head, .v-menu-toggler');
        if (vNavToggle) {
            e.preventDefault();
            e.stopPropagation();
            const nav = vNavToggle.closest('.tophive-vertical-nav');
            if (nav) nav.classList.toggle('open');
            document.body.classList.toggle('v-nav-open');
            return;
        }

        // --- 6. More Nav (Header) ---
        const moreNavToggle = e.target.closest('#more-nav > li > a');
        if (moreNavToggle) {
            e.preventDefault();
            e.stopPropagation();
            moreNavToggle.parentElement.classList.toggle('more-nav-open');
            return;
        }

        // --- Click Outside / Global Close Handlers ---

        // Close Notification Dropdown
        if (!e.target.closest('.th-bp-header-notification-container')) {
            const activeNotif = document.querySelector('.th-bp-header-notification-container ul.show_dd');
            if (activeNotif) activeNotif.classList.remove('show_dd');
        }

        // Close Messenger Dropdown
        if (!e.target.closest('.th-bp-header-messenger-container')) {
            const activeMsg = document.querySelector('.th-bp-header-messenger-container ul.show_dd');
            if (activeMsg) activeMsg.classList.remove('show_dd');
        }

        // Close Vertical Nav
        if (!e.target.closest('.tophive-vertical-nav') && !e.target.closest('.v-menu-toggler')) {
            const vNav = document.querySelector('.tophive-vertical-nav.open');
            if (vNav) {
                vNav.classList.remove('open');
                document.body.classList.remove('v-nav-open');
            }
        }
    });
}